import { render, staticRenderFns } from "./MDSGoods.vue?vue&type=template&id=6ef17cc6&scoped=true&"
import script from "./MDSGoods.vue?vue&type=script&lang=js&"
export * from "./MDSGoods.vue?vue&type=script&lang=js&"
import style0 from "./MDSGoods.vue?vue&type=style&index=0&id=6ef17cc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef17cc6",
  null
  
)

export default component.exports